


export function anonymize_gemini_data(
    conversations,
    search_history, 
    ai_mode, 
    geminiFiles
) {
    var anonymized_user_object = {'conversations': conversations};

    if (search_history !== null) {
        anonymized_user_object['search_history'] = search_history;  
    }
    if (ai_mode !== null) {
        anonymized_user_object['ai_mode'] = ai_mode;
    }
    if (geminiFiles && geminiFiles.length > 0) {
        anonymized_user_object.attachments = geminiFiles.map((path) => path.split('/').pop());
    }
    return anonymized_user_object;
}

